<template>
  <card-item
    card="item_lessonplan_detail"
    :tabs="tabs"
    :activeTab="activeTab"
    :id="id"
    :infoKeys="infoKeys"
  />
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "information_card",
          component: () => import("./Info"),
        },
        {
          title: "Задания",
          key: "works",
          component: () => import("./Works"),
        },
        {
          title: "Ресурсы",
          key: "media",
          component: () => import("./Media"),
        },
      ],
      activeTab: 0,
      infoKeys: [
        {
          key: "title",
          title: "Информация",
        },
      ],
    };
  },
};
</script>